<template>
  <div class="table">
    <el-card shadow="hover">
      <el-tabs
        type="border-card"
        :value="editableTabsValue"
        @tab-click="productTabClick"
      >
        <el-tab-pane label="全部" name="0">
          <Item :tableData="tableData0" @getData="getData" :itemTotal="total0"></Item>
        </el-tab-pane>
        <el-tab-pane label="销售中" name="1">
          <Item :tableData="tableData1" @getData="getData" :itemTotal="total1"></Item>
        </el-tab-pane>
        <el-tab-pane label="已售罄" name="2">
          <Item :tableData="tableData2" @getData="getData" :itemTotal="total2"></Item>
        </el-tab-pane>
        <el-tab-pane label="仓库中" name="3">
          <Item :tableData="tableData3" @getData="getData" :itemTotal="total3"></Item>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import {
  productList,
  checktProductClass,
  createProduct,
  updateProduct,
  updateStatus,
} from "@/api/productList";
import { CreateProduct } from "@/types/api/productList";
import { freightSelectByObj, freightDel } from "@/api/freight";
import quillEditorImgUpload from "@/utils/quillEditorImgUpload";
import print from "@/utils/print";
import { allParentList, checkDict } from "@/api/system";
import TablePagination from "@/mixins/tablePagination";
import Loading from "@/mixins/loading";
import copy from "@/utils/deepCopy";
import Item from "./Item";
import axios from "axios";
import config from "@/config/default";
import filterTime from "@/utils/filterTime";


export default {
  props: {
    keyword: {
      type: String,
    },
    maxPrice: {
      type: String,
    },
    minPrice: {
      type: String,
    },
    maxSale: {
      type: String,
    },
    minSale: {
      type: String,
    },
    publishStatus: {
      type: Number | String,
    },
    productCategoryId: {
      type: Number | String,
    },
    dictionary: {
      type: Array,
      default: [],
    },
  },
  components: { Item },
  mixins: [Loading],
  data() {
    return {
      editableTabsValue: "0",
      tableData0: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      total0: 0,
      total1: 0,
      total2: 0,
      total3: 0,
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    productTabClick(val) {
      this.editableTabsValue = val.name;
      this.getData();
    },
    // 导出excel
  importExcel() {
    let productStatus = this.editableTabsValue;
      let realProductStatus = "";
      if (productStatus > 0) {
        realProductStatus = productStatus;
      }
      this.showLoading();
    axios({
      // 指定请求方式
      method: "get",
      url: config.baseUrl + "/pms/product/excel/exportProductListInfo",
      // 请求类型为blob
      responseType: "blob",
      withCredentials: true, // 允许附带cookit
      headers: {
        Authorization: this.$store.getters.token, // 附带的token
      },
      params: {
        maxPrice: this.maxPrice,
        minPrice: this.minPrice,
        maxSale: this.maxSale,
        minSale: this.minSale,
        keyword: this.keyword,
        productStatus: realProductStatus,
        productCategoryId:this.productCategoryId == 0 ? null : this.productCategoryId,
      }
    })
      .then((res) => {
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" }); // res就是接口返回的文件流了
        let objectUrl = URL.createObjectURL(blob);
        let a = document.createElement("a");
        let time = filterTime(Date.now());
        console.log(time);
        a.setAttribute("href", objectUrl);
        a.setAttribute("download", `养博城后台商品表单${time}.xls`);
        a.click();
        this.hideLoading();
      })
      .catch((err) => {
        this.hideLoading();
        this.$message.error(err);
      });
  },
    // 获取数据
    getData(currentPage,pageSize) {
      let productStatus = this.editableTabsValue;
      let realProductStatus = "";
      if (productStatus > 0) {
        realProductStatus = productStatus;
      }
      this.showLoading();
      productList({
        maxPrice: this.maxPrice,
        minPrice: this.minPrice,
        maxSale: this.maxSale,
        minSale: this.minSale,
        keyword: this.keyword,
        productStatus: realProductStatus,
        productCategoryId:
          this.productCategoryId == 0 ? null : this.productCategoryId,
        pageSize: pageSize||10,
        pageNum: currentPage||1,
      }).then((res) => {
        let { total, pageSize, list, pageNum } = res.data;
        list.forEach((e) => {
          e.imgs = (e.pictures && e.pictures.split(",")) || [];
        });
        this["tableData" + productStatus] = list;
        this["total" + productStatus] = total;
        this.hideLoading();
      });
    }
  }
};
</script>
<style lang="scss" scoped src="../style.scss">
</style>
<style lang="scss" scoped>
.input {
  width: inherit;
}
</style>